(function () {
    'use strict';

    angular
        .module('planInitiativeModule')
        .controller('grcPlanInitiativeRiskSelectorController', Controller);

    Controller.$inject = ['$scope', 'businessPlanningService'];

    function Controller($scope, businessPlanningService) {

        /**
         * From Parent Scope
         *
         * @property {object} $scope.initiative
         * @property {function} $scope.onRiskSelected
         * @property {array} $scope.selectedRisks
         */

        $scope.ctrlCtxt = {
            isLoading: false,
            availableMitigatedRisks: null,
            selectedMitigatedRisks: null
        };

        init();

        function init() {
            $scope.ctrlCtxt.isLoading = true;
            businessPlanningService
                .getAllMitigatedRisks($scope.initiative.PlanInitiativeID)
                .then(function (buRiskList) {
                    // isEmpty covers null and ''
                    if (_.isEmpty(buRiskList)) buRiskList = {
                        Risks: [],
                        RisksOfAssessorsInSiblingBusinessUnits: [],
                        UserBusinessUnit: null
                    };

                    // Remove Sibling BU without Risks
                    _.remove(buRiskList.RisksOfAssessorsInSiblingBusinessUnits, function (buWithMitigatedRisks) {
                        return !buWithMitigatedRisks.Risks || buWithMitigatedRisks.Risks.length === 0;
                    });

                    $scope.ctrlCtxt.availableMitigatedRisks = filterSelectedRisks(buRiskList);
                    $scope.ctrlCtxt.hasAvailableRisk = $scope.ctrlCtxt.availableMitigatedRisks.Risks.length > 0;

                    if ($scope.ctrlCtxt.availableMitigatedRisks.Risks.length === 0) {
                        $scope.ctrlCtxt.hasAvailableRisk = _.some(buRiskList.RisksOfAssessorsInSiblingBusinessUnits, function (siblingBURisks) {
                            return siblingBURisks.Risks.length > 0;
                        });
                    }

                })
                .finally(function () {
                    $scope.ctrlCtxt.isLoading = false;
                });
        }
        
        function filterSelectedRisks(mitigatedRisks) {

            // User's BU Risks
            mitigatedRisks.Risks = _.differenceBy(mitigatedRisks.Risks, $scope.selectedRisks, 'RiskID');

            // Remove selected Risks from Sibling BU Risks, removing the whole object if list is empty
            mitigatedRisks.RisksOfAssessorsInSiblingBusinessUnits =
                _.differenceWith(mitigatedRisks.RisksOfAssessorsInSiblingBusinessUnits, $scope.selectedRisks, function (siblingBURisks) {
                    siblingBURisks.Risks = _.differenceBy(siblingBURisks.Risks, $scope.selectedRisks, 'RiskID');

                    // Return true to remove the item from the list
                    return siblingBURisks.Risks.length === 0;
                });
            return mitigatedRisks;
        }
    }
})();